var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RoofWindowOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h-6.28L21.43 22.47 9 32.73v-5.19l12.44-10.26 13.18 11 3.12-3.75 3 2.53 19.32-7 1.36 3.75L44.29 30 61.8 44.68l-3 3.66L68 56zM12 38h22v20H12V38zm13 16h5V42h-5v12zm-9 0h5V42h-5v12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roof_window_open.61f3e6cb.svg";
export { SvgC1RoofWindowOpen as ReactComponent };